<template>
    <div>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            v-loading="isBusy"
            element-loading-spinner="el-icon-loading"
            label-width="170px"
        >
            <el-form-item label="Contact" prop="contact">
                <contact-select
                    :url="searchContactUrl"
                    v-model="selectedContact"
                ></contact-select>
            </el-form-item>
            <el-form-item label="Outgoing Number" prop="outgoing_number_id">
                <el-select v-model="form.outgoing_number_id" class="w-100">
                    <el-option
                        v-for="{key, label} in outgoingNumberList"
                        :key="key"
                        :label="label"
                        :value="key"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-button type="primary" @click="store">Save</el-button>
    </div>
</template>

<script>
  import BaseForm from '../form';
  import ContactSelect from '../contact-select';

  export default {
    extends: BaseForm,

    components: {
      ContactSelect,
    },

    props: {
      searchContactUrl: String,
      outgoingNumberList: Array,
    },

    data() {
      const form = {
        contact_id: null,
        outgoing_number_id: null,
      };

      return {
        form,
        rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
        selectedContact: null,
      };
    },

    watch: {
      selectedContact(val) {
        this.form.contact_id = val;
      },
    },

    methods: {
      /**
       * @param {Object} model
       */
      initForm(model) {
        this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
      },
    },
  }
</script>

